module.exports = __webpack_public_path__ + "img/api-huobi.be157845.png";